<template>
  <div class="module-list-wrap">
    <div class="nav-list">
      <div class="nav-list-left">
        <el-button class="icon" @click="leftmove" style="margin-right: 10px;padding:0;">
          <i class="el-icon-arrow-left"></i>
        </el-button>
        <!--          <i class="el-icon-arrow-left icon" style="margin-right: 10px" @click="leftmove"></i>-->
        <ul class="module-list" ref="navList" id="navList">
          <div
            class="menu-item"
            @click="indexClick"
            style="padding-right: 10px;margin-left:0;"
            :class="{'active':$route.fullPath == '/index'}"
          >首页
          </div>
          <li v-for="(item,index) in (menuList.length>0?menuList.filter(v=>v.url!='/index'):localMenuList.filter(v=>v.url!='/index'))" :key="index" class="menu-item" :class="{'active':item.active}">
            <div style="text-align: center">
              <span @click="menuClick(item)">{{item.name}}</span>
              <span class="close-icon" @click="closeMenu(item)">×</span>
            </div>
          </li>
        </ul>
      </div>
      <!--        <i class="el-icon-arrow-right icon" style="margin:0 10px" @click="rightmove"></i>-->
      <el-button class="icon" @click="rightmove" style="margin:0 10px;padding:0;">
        <i class="el-icon-arrow-right"></i>
      </el-button>
    </div>
    <el-dropdown @command="closePage" v-if="localMenuList.length>0 || menuList.length>0">
        <span class="el-dropdown-link">
          <i slot="reference" class="el-icon-close"></i>
        </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="currentPage">关闭当前页面</el-dropdown-item>
        <el-dropdown-item command="allPage">关闭所有页面</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
export default {
  data() {
    return {
      localMenuList: [],
      number: 0,
      leftDisabled:false,
      rightDisabled:false,
      // scrollLeftWidth:0,
      isDisabled:true,
    };
  },
  computed: {
    menuList() {
      return this.$store.state[this.$utils.storeKeys.CLICKMENU]
    },
    scollLeft(){
      return document.getElementById('navList').scrollLeft
    },
    // isDisabled(){
    // let scrollLeft = document.getElementById('navList').scrollLeft
    // if(scrollLeft>0){
    //   return false
    // }else{
    //   return true
    // }
    // console.log(document.getElementById('navList').scrollLeft)
    // }
  },
  watch: {
    $route(to, from) {
      // to 和 from 都是 路由信息对象
      let menuList = this.$utils.getClickMenu();
      let currentMenu = menuList.filter((item) => {
        return item.url == from.fullPath
      });
      if(currentMenu.length>0){
        if(to.fullPath == '/index'){
          currentMenu[0].active = false;
        }
        this.$utils.setClickMenu(menuList);
        this.$store.commit(this.$utils.storeKeys.CLICKMENU, menuList);
      }
    },
  },
  created() {
    this.localMenuList = this.$utils.getClickMenu();
  },
  methods: {
    // 左箭头
    leftmove() {
      if (this.number == 0) {
        this.number = 0;
      }else{
      }
      this.number --
      this.$refs.navList.scrollLeft = this.number * 104
    },
    // 右箭头
    rightmove() {
      if (this.$refs.navList.scrollWidth == this.$refs.navList.scrollLeft + this.$refs.navList.clientWidth) {
        this.number = this.number
      }else{
        this.number ++
      }
      this.$refs.navList.scrollLeft = this.number * 104
    },
    menuClick(menu) {
      this.addMenuList(menu);
      this.$router.push({ path: menu.url.trim() });
    },
    indexClick() {
      this.$router.push({ path: "/index" });
      let menuList = this.$utils.getClickMenu()
      menuList.map((item) => {
        item.active = false;
      });
      this.$utils.setClickMenu(menuList);
      this.$store.commit(this.$utils.storeKeys.CLICKMENU, menuList);
    },
    addMenuList(menu) {
      let menuList = this.$utils.getClickMenu().filter(v=>v.url!='/index')
      menuList.map((item) => {
        item.active = false;
      });
      let currentMenu = menuList.filter((item) => {
        return item.url == menu.url;
      });
      currentMenu[0].active = true;
      this.$utils.setClickMenu(menuList);
      this.$store.commit(this.$utils.storeKeys.CLICKMENU, menuList);
    },
    // 关闭所有页面
    closePage(val){
      if(val==='currentPage'){//关闭当前页
        if(this.$route.fullPath != '/index'){
          let menuList = this.$utils.getClickMenu();
          let menuIndex = menuList.findIndex((item) => this.$route.fullPath.indexOf(item.url)!=-1);
          let url = ''
          if(menuIndex == 0){// 如果active在最开始
            if (menuList.length == 1) {
              url = "/index";
              this.localMenuList = []
            } else {
              menuList[1].active = true;
              url = menuList[1].url;
            }
            this.$router.push({ path: url });
          }else{
            menuList[menuIndex - 1].active = true;
            url = menuList[menuIndex - 1].url;
            this.$router.push({ path: url })
          }
          menuList.splice(menuIndex, 1);
          this.$utils.setClickMenu(menuList);
          this.$store.commit(this.$utils.storeKeys.CLICKMENU, menuList);
        }
      }else{//关闭所有
        this.$utils.setClickMenu([]);
        this.$store.commit(this.$utils.storeKeys.CLICKMENU, []);
        this.localMenuList = []
        this.indexClick()
      }
    },
    // 关闭
    closeMenu(menu) {
      let menuList = this.$utils.getClickMenu();
      let menuIndex = menuList.findIndex((item) => {
        return item.url === menu.url;
      });
      console.log(menuIndex)
      let url = "";
      if (menuIndex === 0) {// 如果active在最开始
        if (menuList.length === 1) {
          url = "/index";
          this.localMenuList = []
        } else {
          menuList[1].active = true;
          url = menuList[1].url;
        }
      } else {
        if(this.$route.fullPath.indexOf(menu.url)!=-1){
          // if(menu.url == this.$route.fullPath){
          for(let i=0;i<menuList.length;i++){
            menuList[i].active = false;
          }
          menuList[menuIndex - 1].active = true;
          url = menuList[menuIndex - 1].url;
        }
      }
      menuList.splice(menuIndex, 1);
      this.$utils.setClickMenu(menuList);
      this.$store.commit(this.$utils.storeKeys.CLICKMENU, menuList);
      if(this.$route.fullPath.indexOf(menu.url)!=-1)
        this.$router.push({ path: url });
    },
  },
};
</script>
<style scoped>
.module-list-wrap{
  width: 100%;
  display: flex;
  padding:10px 20px 5px 20px;
  justify-content: space-between;
  border-bottom:2px solid #e4e4e4;
}
.module-list-wrap .nav-list{
  display: flex;
  justify-content: space-between;
  flex: 1;
  overflow-x: hidden;
  overflow-y:hidden;
  white-space:nowrap;
}
.nav-list-left{
  display: flex;
  justify-content: space-between;
  overflow-x: hidden;
  overflow-y:hidden;
  white-space:nowrap;
}
.module-list-wrap .el-icon-close{
  border:1px solid #d8d8d8;
  text-align: center;
  height: 28px;
  min-width: 28px;
  line-height: 28px;
  border-radius: 4px;
}
.module-list-wrap .el-icon-close:hover{
  cursor: pointer;
  color:#458cff;
  border:1px solid #458cff;
}
.module-list-wrap .icon{
  height: 30px;
  min-width: 30px;
  line-height: 30px;
}

.module-list-wrap .module-list{
  overflow-x: hidden;
  overflow-y:hidden;
  white-space:nowrap;
}
.module-list-wrap .module-list li{
  font-style: normal;
  display: inline-block;
  /*width: 150px;*/
}
.module-list-wrap .menu-item {
  height: 30px;
  line-height: 30px;
  border: 1px solid #d8d8d8;
  border-radius: 5px;
  margin-left: 10px;
  padding:0 30px 0 10px;
  position: relative;
  cursor: pointer;
  font-size: 13px;
  display: inline-block;
}
.module-list-wrap .menu-item.active {
  background-color: #458cff;
  color: #fff;
}
.module-list-wrap .menu-item .close-icon {
  position: absolute;
  width: 30px;
  height: 30px;
  right: 0px;
  top: 0;
  text-align: center;
  line-height: 30px;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/business/navList.vue